import { useEffect } from "react";

export function useDefaultResponseValues(cardHtml: HTMLElement) {
  useEffect(() => {
    const dateInput = cardHtml.getElementsByClassName("ac-dateInput").item(0);
    if (dateInput) {
      const now = new Date();
      const nowWithTimeZoneOffset = new Date(now.getTime() - now.getTimezoneOffset() * 60 * 1000);
      const todayDateString = nowWithTimeZoneOffset.toISOString().split("T")[0];
      dateInput.setAttribute("value", todayDateString);
    }

    const timeInput = cardHtml.getElementsByClassName("ac-timeInput").item(0);
    if (timeInput) {
      const now = new Date();
      const nowWithTimeZoneOffset = new Date(now.getTime() - now.getTimezoneOffset() * 60 * 1000);
      const timeString = nowWithTimeZoneOffset
        .toISOString()
        .split("T")[1]
        .split(".")[0]
        .slice(0, -3);
      timeInput.setAttribute("value", timeString);
    }
  }, [cardHtml]);
}
